import { Flex, Page } from 'components';
import React, { ReactElement } from 'react';
import { createGlobalStyle } from 'styled-components';

const HpCss = createGlobalStyle`
    body {
        overflow: hidden;
        background: ${({ theme }) => theme.colors.dark_150};
    }
`;

const Hp = (): ReactElement => (
  <Page title="HP Virtual">
    <Flex bg="dark_150" height="100vh">
      <iframe title="HP Virtual" src="/hp12c/index.html" width="600" height="375" frameBorder="0" />
      <HpCss />
    </Flex>
  </Page>
);

export default Hp;
